import { motion } from 'framer-motion';
import styled from 'styled-components';

export const StyledLoopTopRightUserMenuContainer = styled(motion.div)`
    position: absolute;
    top: 0;
    right: 0;
    z-index: 3;
    display: flex;
    padding: 22px 30px 16px 18px;
    height: 70px;
    width: auto;
    background-color: ${(p) => p.theme.colors.white};
    border-bottom-left-radius: 28px;
    box-sizing: border-box;
`;

export const StyledLoopTopRightEdgeContainer = styled.div`
    width: 0%;
    height: 0%;
    display: flex;

    &::after,
    &::before {
        content: 'a';
        color: transparent;
        position: absolute;
        width: 28px;
        height: 28px;
    }

    &::before {
        height: 38px;
        top: 0;
        right: 100%;
        background: radial-gradient(circle 20px at 0 38px, rgba(255,255,255,0) 28px, #ffffff 100%);
    }
    &::after {
        width: 38px;
        top: 100%;
        right: 0;
        background: radial-gradient(circle 20px at 0px 28px, rgba(255,255,255,0) 28px, #ffffff 100%);
    }
`;

export const StyledLoopTopRightUserMenu = styled(motion.img)<{ $clickable?: boolean }>`
    width: 100%;
    cursor: ${(p) => (p.$clickable ? 'pointer' : 'default')};
`;

export const StyledTopRightAvatarWrapper = styled.div`
    width: 100%;
    position: relative;
`;

export const StyledTopRightAvatarContent = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 120px;
    flex-wrap: nowrap;
    cursor: pointer;
    justify-content: space-between;
`;

export const StyledTopRightAvatarContentText = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: nowrap;
    & > :first-child {
        padding: 0;
    }
`;

export const StyledChevronIcon = styled.img<{ $flip: boolean }>`
    width: 14px;
    height: 14px;
    box-sizing: border-box;
    aspect-ratio: 1;
    mix-blend-mode: darken;
    transform: rotate(${(p) => (p.$flip ? '180deg' : '0deg')});
    transition: transform 0.2s ease-in-out;
    cursor: pointer;
`;

export const StyledProfileDropdownContainer = styled.div`
    position: absolute;
    top: calc(100% + 8px);
    right: -10px;
    width: 200px;
    border-radius: 8px;
    z-index: 2;
`;

export const StyledProfileDropdownItems = styled.div`
    border: 1px solid ${(p) => p.theme.colors.seafoamGray};
    background-color: ${(p) => p.theme.colors.white};
    border-radius: 8px;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
`;

export const StyledProfileDropdownItem = styled.div`
    padding: 12px 20px;
    border-radius: 8px;
    box-sizing: border-box;
    cursor: pointer;
    &:hover {
        background-color: ${(p) => p.theme.colors.surface0};
    }
`;

export const StyledChevronWrapper = styled.div`
    margin-left: auto;
    display: flex;
    align-items: center;
`;
